import { useContext, useEffect, useMemo, useRef, useState } from "react";
import TableItem from "../TableItem";
import { GraphConfiguration } from "@/type/common";
import AuthContext from "@/store/contexts/AuthContext";
import { loadData } from "@/lib/load-data";
import { refactor_config } from "@/utils/refactor";

const TableItemLoader = ({ id, editing }: { id: string; editing: boolean }) => {
  const { configs, models } = useContext(AuthContext);
  const [config, setConfig] = useState<GraphConfiguration | null>(null);
  const [data, setData] = useState<any[]>([]);
  const [enrichedConfig, setEnrichedConfig] = useState<GraphConfiguration | null>(null);
  const loadedConfig = useRef<string | null>(null);

  useEffect(() => {
    const config = configs.find((c) => c.id === id);
    setConfig(config || null);
  }, [id, configs]);

  useEffect(() => {
    if (!config || loadedConfig.current === JSON.stringify(config)) return;
    loadData(refactor_config(config)).then((data) => {
      if (!data || data.length === 0) return;
      const obj = data[0];
      const result = obj[Object.keys(obj)[0]];
      setData(result.data || []);
      
      // Create enriched config with enriched groupBy from backend
      if (result.enriched_group_by && config) {
        const enriched = {
          ...config,
          data_source: {
            ...config.data_source,
            groupBy: result.enriched_group_by
          }
        };
        setEnrichedConfig(enriched);
      } else {
        setEnrichedConfig(config);
      }
      
      loadedConfig.current = JSON.stringify(config);
    });
  }, [config]);

  const emptyConfig = useMemo(() => ({} as GraphConfiguration), []);

  return (
    <TableItem config={enrichedConfig || config || emptyConfig} data={data} models={models} />
  );
};

export default TableItemLoader;
